var map = {
	"./icon_2.svg": "bc96",
	"./like_2.svg": "792c",
	"./message_2.svg": "3158",
	"./news_2.svg": "4243",
	"./photoSlider_2.svg": "4363",
	"./player_2.svg": "21e0",
	"./profile_2.svg": "fe69",
	"./record_2.svg": "7039",
	"./search_2.svg": "612b",
	"./share_2.svg": "f4de",
	"./videoSlider_2.svg": "51dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "330c";